const PLAYER_NAMES = [
  'Sarah',
  'Alex',
  'Jordan',
  'Maya',
  'Chris',
  'Sam',
  'Taylor',
  'Jamie',
  'Riley',
  'Morgan',
  'Casey',
  'Avery',
  'Quinn',
  'Parker',
  'Reese',
  'Drew',
  'Rowan',
  'Jules',
  'Skyler',
  'Emerson',
  'Harper',
  'Kendall',
  'Cameron',
  'Blake',
  'Micah',
];

export function getRandomUniqueNames(count: number): string[] {
  const clamped = Math.max(0, Math.min(count, PLAYER_NAMES.length));
  const pool = [...PLAYER_NAMES];
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  return pool.slice(0, clamped);
}

